import axios from "axios";
import Search from "../Menu/Search";
import MenuDrawer from "../Menu/MenuDrawer";
import logo from "../../Assets/images/logo.svg";
import MenuIcon from "@mui/icons-material/Menu";
import baseURL from "../../Assets/common/baseURL";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  Box,
  Badge,
  Button,
  AppBar,
  Toolbar,
  useTheme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import API from "../../utils/API";

function StickyHeader(props) {
  const theme = useTheme();
  const navigate = useNavigate();

  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  // ✅ Brands state
  const [brands, setBrands] = useState([]);
  const [drawerMenuOpen, setDrawerMenuOpen] = useState(false);

  useEffect(() => {
    loadCategories();
  }, []);

  // Categories, Subcategories, aur Brands ka data load karna
  const loadCategories = async () => {
    try {
      const res = await API({
        method: "GET",
        url: "category",
      });
      setCategories(res);
    } catch (error) {
      console.error("Error loading categories:", error);
    }

    try {
      const subCategoriesRes = await API({
        method: "GET",
        url: "subcategory_slug",
      });
      setSubCategories(subCategoriesRes);
    } catch (error) {
      console.error("Error loading subcategories:", error);
    }

    // Brands data fetch kiya gaya
    try {
      const brandsRes = await API({
        method: "GET",
        url: "brand_slug",
      });
      // Sirf top 10 brands jo web par display hon
      const top10Brands = brandsRes
        .filter((item) => item.web === true)
        .slice(0, 10);
      setBrands(top10Brands);
    } catch (error) {
      console.error("Error loading brands:", error);
    }
  };

  // ✅ Category Names ka Array
  const categoryNames = [
    "Baby Care",
    "Beauty",
    "Consumer Goods",
    "Health Care Devices",
    "Lifestyle & Fitness",
    "Medicines",
    "Surgical",
    "Brands", // Brands ko hardcoded list mein add kiya gaya
  ];

  return (
    <AppBar position="sticky" sx={{ background: "#fff" }}>
      {/* TOP TOOLBAR: Logo, Search, Cart Icon */}
      <Toolbar
        variant="dense"
        sx={{ justifyContent: "space-between", marginTop: 1 }}
      >
        {isMatch && (
          <>
            <MenuIcon
              color="primary"
              fontSize="large"
              onClick={() => setDrawerMenuOpen(true)}
            />

            <MenuDrawer
              open={drawerMenuOpen}
              categories={categories}
              setOpen={setDrawerMenuOpen}
              authStatus={props.authStatus}
              subCategories={subCategories}
              brands={brands} // Brands mobile menu ke liye
            />
          </>
        )}

        <div style={{ cursor: "pointer" }}>
          <img
            src={logo}
            alt={"NMP Pharmacy"}
            style={{ height: "90%", width: "90%" }}
            onClick={() => {
              navigate("/");
              document.documentElement.scrollTo(0, 0);
            }}
          />
        </div>

        {!isMatch && (
          <div style={{ marginRight: 20, marginLeft: -100, width: "35%" }}>
            <Search />
          </div>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {/* Cart Icon */}
          <Box sx={{ cursor: "pointer" }} onClick={() => props.setOpen(true)}>
            <Badge
              badgeContent={props.cartItems.Items.length}
              color="secondary"
            >
              <ShoppingCartIcon color="primary" fontSize="large" />
            </Badge>
          </Box>
        </Box>
      </Toolbar>

      {/* SINGLE BOTTOM TOOLBAR: Categories, Brands aur Buttons */}
      {!isMatch && (
        <>
          <Toolbar variant="dense">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                padding: "0 10px",
                // Categories aur Buttons ko vertically align karne ke liye
                alignItems: "stretch",
              }}
            >
              {/* Categories aur Brands ka section (Left Side) */}
              {/* ✅ Ab hum hardcoded names use karenge image ke layout ke liye */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {categoryNames.map((name, index) => {
                  // Category aur Brands ke liye data nikalna
                  const currentCategory = categories.find(
                    (cat) => cat.name === name
                  );
                  const isBrandsLink = name === "Brands";

                  return (
                    <div key={index} className="navigation">
                      <a
                        
                        style={
                          isBrandsLink
                            ? {
                                backgroundColor: "#DA1212",
                                color: "#fff",
                                padding: "10px 12px",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                textDecoration: "none",
                                marginLeft: "10px",
                              }
                            : {}
                        }
                      >
                        {name}
                      </a>

                      {/* Dropdown Content */}
                      <div className="navigation-content"
                      style={{ paddingTop: isBrandsLink ? '4px' : '-0px' }}
                      >
                        {/* Brands Dropdown Content (Top 10 Brands) */}
                        {isBrandsLink &&
                          brands.map((brand) => (
                            <a
                              key={brand.id}
                              href={`/brand/${brand.slug}`}
                              style={{ fontSize: 11 }}
                              onClick={() => {
                                navigate(`/brand/${brand.slug}`);
                                document.documentElement.scrollTo(0, 0);
                              }}
                            >
                              {brand.name}
                            </a>
                          ))}

                        {/* Categories Subcategories Dropdown Content */}
                        {!isBrandsLink &&
                          currentCategory &&
                          subCategories.map((subCategory) => {
                            if (
                              currentCategory.id ===
                                subCategory.parent_category &&
                              subCategory.name !== "General Items"
                            ) {
                              return (
                                <a
                                  key={subCategory.id}
                                  href={
                                    subCategory.name === "A to Z"
                                      ? "/showproducts"
                                      : `/subcategory/${subCategory.slug}`
                                  }
                                  style={{ fontSize: 12 }}
                                >
                                  {subCategory.name}
                                </a>
                              );
                            }

                            return null;
                          })}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Buttons ka section (Right Side) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  height: "100%",
                  flexWrap: "nowrap",
                }}
              >
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    minWidth: 160,
                    textAlign: "start",
                    height: 40,
                    padding: "6px 16px",
                    textTransform: "none",
                    fontSize: "0.875rem",
                  }}
                  onClick={() => navigate("/consult-pharmacist")}
                >
                  Consult with Pharmacist
                </Button>

                <Button
                  color="primary"
                  variant="contained"
                  sx={{
                    minWidth: 160,
                    textAlign: "start",
                    height: 40,
                    padding: "6px 16px",
                    textTransform: "none",
                    fontSize: "0.875rem",
                  }}
                  onClick={() => navigate("/fastorder")}
                >
                  Create Fast Order
                </Button>
              </div>
            </div>
          </Toolbar>
        </>
      )}
    </AppBar>
  );
}

const mapStateToProps = (state) => {
  const { cartItems } = state;
  return { cartItems: cartItems };
};

export default connect(mapStateToProps)(StickyHeader);
